import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import React from 'react'
import './ApplyV2ReviewApplySkills.scss'

const baseClass = 'ApplyV2ReviewApplySkills'

interface Props {
    className?: string
}

function ApplyV2ReviewApplySkills({ className = '' }: Props) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
    } = useApplyV2Context()
    const data = postProfileData?.data?.skill || []

    return (
        <div className={`${baseClass} ${className}`}>
            {data.map((skill) => (
                <div key={skill.existingId || skill.uid} className={`${baseClass}__item`}>
                    {skill.skill}
                </div>
            ))}
        </div>
    )
}

export default ApplyV2ReviewApplySkills
